"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const osmosysIcons_1 = require("./osmosysIcons");
const overlays_1 = require("../overlays");
exports.OsmosysIcon = (_a) => {
    var { osysIcon, iconStyle = 'light', marginRight, marginLeft, tooltip, tooltipSpan } = _a, props = tslib_1.__rest(_a, ["osysIcon", "iconStyle", "marginRight", "marginLeft", "tooltip", "tooltipSpan"]);
    if (marginRight === true) {
        marginRight = 2;
    }
    if (marginLeft === true) {
        marginLeft = 2;
    }
    props.className = classnames_1.default(props.className, {
        [`mr-${marginRight}`]: marginRight !== undefined && !isNaN(marginRight),
        [`ml-${marginLeft}`]: marginLeft !== undefined && !isNaN(marginLeft),
    });
    const icon = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ "data-osmosys-comp": "OsmosysIcon", icon: osmosysIcons_1.osmosysIcons[iconStyle][osysIcon] }, props)));
    if (tooltip) {
        return (react_1.default.createElement(overlays_1.OsmosysTooltip, { span: tooltipSpan, label: tooltip }, icon));
    }
    return icon;
};
//# sourceMappingURL=OsmosysIcon.js.map